// library imports
import * as React from "react";
import { Grid } from "@mui/material";
import CreateIcon from "@mui/icons-material/Create";
import { useHistory } from "react-router-dom";

// auth helpers
import SearchToolsWidget from "./SearchToolsWidget";
import SearchResultsWidget from "./SearchResultsWidget";
import UnsavedChangesModal from "../modals/UnsavedChangesModal";
import EditTitleModal from "./EditTitleModal";
import PendingActionWidget from "./PendingActionWidget";
import { useParams } from "react-router-dom";
import { getHeaders } from "../utils/HeaderHelper";
import { useFlash } from "../FlashContext";

interface SortObject {
  field: string;
  direction: "desc" | "asc";
}

// component imports
interface Props {
  csrfToken: string;
  menu_track_src: string;
  sort_plain_src?: string;
  sort_ascending_src?: string;
  sort_descending_src?: string;
  chat_icon_with_orange_line?: string;
  the_wall_icon_grey?: string;
  pencil_grey?: string;
  user_id?: string;
  patient_reports_icon?: string;
}

const PatientListCreate: React.FC<Props> = (props: any) => {
  const history = useHistory();
  const { showToast } = useFlash();
  const { id: patientListId} = useParams();
  const [patientList, setPatientList] = React.useState<any>(null);
  const [paramsPresent, setParamsPresent] = React.useState<boolean>(true);
  const [searchPatients, setSearchPatients] = React.useState<any>([]);
  const [checkedList, setCheckedList] = React.useState<any>([]); // Now stores IDs
  const [pendingAdd, setPendingAdd] = React.useState<any>([]); // Now stores IDs
  const [pendingRemoval, setPendingRemoval] = React.useState<any>([]); // Now stores IDs
  const [onList, setOnList] = React.useState<any>([]); // Now stores IDs
  const [allMatchingPatientIds, setAllMatchingPatientIds] = React.useState<number[]>([]);
  const [isSelectAllActive, setIsSelectAllActive] = React.useState<boolean>(false);
  
  const [patientListName, setPatientListName] = React.useState<string>("");
  const [unsavedChanges, setUnsavedChanges] = React.useState<boolean>(false);
  const [editTitle, setEditTitle] = React.useState<boolean>(false);
  const [editMissingTitle, setEditMissingTitle] = React.useState<boolean>(false);
  const [listName, setListName] = React.useState<string>("");
  const [loading, setLoading] = React.useState<boolean>(false);
  const [saveRedirect, setSaveRedirect] = React.useState<boolean>(false);
  // Track initial state
  const initialPatientListName = React.useRef<string>("");
  const initialCheckedList = React.useRef<any[]>([]); // Stores IDs
  const allMatchingPatientsRef = React.useRef<any[]>([]); // Store all matching patients with on_list info
  const [currentPage, setCurrentPage] = React.useState<number>(1);
  const [totalPages, setTotalPages] = React.useState<number>(1);
  const [sortObject, setSortObject] = React.useState<any>({
    field: "last_name",
    direction: "asc",
  });

  console.log("searchPatients", searchPatients);
  console.log("checkedList", checkedList);
  console.log("pendingAdd", pendingAdd);
  console.log("pendingRemoval", pendingRemoval);
  console.log("onList", onList);
  console.log("initialCheckedList", initialCheckedList);

  const handleSave = () => {
    if (!patientListName) {
      showToast({
        title: "Patient List Name Required",
        text : "Patient list name is required.",
        type: "error",
      });
      setEditMissingTitle(true)
      return;
    }

    console.log("pendingAdd in handleSave", pendingAdd)
    console.log("pendingRemoval in handleSave", pendingRemoval)
    console.log("pendingAdd in handleSave", pendingAdd)

    var body = {
      pending_add_ids: pendingAdd, // Already IDs
      pending_removal_ids: pendingRemoval, // Already IDs
      name: patientListName,
      patient_list_id: null,
    };

    if (patientList) {
      body.patient_list_id = patientListId;
    }

    fetch("/patient_lists", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": props.csrfToken,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.success == false) {
          console.log(data.error);
          showToast({
            title: "Error Creating Patient List",
            text: "Failed to create patient list.",
            type: "error",
          });
        } else {
          setUnsavedChanges(false);
          initialPatientListName.current = patientListName;
          initialCheckedList.current = [...checkedList];
          setSaveRedirect(true); //calls redirects 
        }
      })
      .catch((error) => {
        console.log(error);
        showToast({
          title: "Error Creating Patient List",
          text: "An error occurred while creating the patient list.",
          type: "error",
        });
      });
  };
  
  const updateName = () => {
    if (!patientListId) {
      showToast({
        title: "Error",
        text: "Cannot update name for unsaved patient list. Please save the list first.",
        type: "error",
      });
      return;
    }

    if (!patientListName) {
      showToast({
        title: "Patient List Name Required",
        text: "Patient list name required.",
        type: "error",
      });
      return;
    }

    var body = {
      name: patientListName,
      patient_list_id: patientListId,
    };

    fetch("/patient_lists", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": props.csrfToken,
      },
      body: JSON.stringify(body),
    })
      .then((response) => response.json())
      .then((data) => {
        if (data?.success == false) {
          console.log(data.error);
          showToast({
            title: "Error Updating Patient List Name",
            text: "Failed to update name.",
            type: "error",
          });
        } else {
          initialPatientListName.current = patientListName;
          initialCheckedList.current = [...checkedList];
        }
      })
      .catch((error) => {
        console.log(error);
        showToast({
          title: "Error Updating Patient List Name",
          text: "An error occurred while updating name.",
          type: "error",
        });
      });
  }

  const handleDiscard = () => {
    setPatientListName(initialPatientListName.current);
    setCheckedList([...initialCheckedList.current]);
    // Reset user.list_status to initial state
    const resetPatients = searchPatients.map((patient) => {
      // Check if patient ID is in initial checked list
      const isInitiallyChecked = initialCheckedList.current.includes(patient.id);
      if (isInitiallyChecked) {
        const status = patient.on_list ? "On List" : "Pending Add";
        return { ...patient, list_status: status };
      } else {
        const status = patient.on_list ? "Pending Removal" : "Not on List";
        return { ...patient, list_status: status };
      }
    });
    setSearchPatients(resetPatients);
    setUnsavedChanges(false);
    setPendingAdd([]);
    setOnList(initialCheckedList.current);
    setPendingRemoval([]);
    setIsSelectAllActive(false);
    setParamsPresent(false);
  };

  const setInitialCheckedList = (patientIds: any[]) => {
    initialCheckedList.current = patientIds;
    setCheckedList(patientIds);
  };

  const getPatientList = async () => {
    // console.log("calling getPatientList()")
    const response = await fetch(`/patient_lists/${patientListId}/?sort_by=${sortObject.field}&sort_direction=${sortObject.direction}`, {
      method: "GET",
      headers: getHeaders(props.csrfToken),
    });
    if (response.status === 404) {
      window.location.href = "/not-found";
      return;
    }
    const result = await response.json();
    if (result.success == false) {
      // alert(result.error);
      console.log(result.error)
      setTimeout(() => {
        window.location.href = "/patient-lists";
      }, 1000)
    } else {
      setPatientList(result.patient_list);
      // console.log("setting patient list name on getPatientList")
      setPatientListName(result.patient_list.name);
      initialPatientListName.current = result.patient_list.name;
    }
  };

  // redirects after save
  React.useEffect(() => {
    if(!saveRedirect){
      return
    }
    setSaveRedirect(false);
    if (patientListId) {
      showToast({
        title: "Patient List Updated",
        text : "You have successfully updated your patient list",
        type: "success",
      });
      history.push("/patient-lists");
    } else {
      showToast({
        title: "Patient List Created",
        text : "You have successfully created a new patient list",
        type: "success",
      });
      history.push("/patient-lists");
    }
  }, [saveRedirect]);

  // Set unsaved changes modal
  React.useEffect(() => {
    if (patientListId) {
      const hasUnsavedChanges =
        checkedList.length !== initialCheckedList.current.length ||
        !checkedList.every((id, index) => id === initialCheckedList.current[index]);
      setUnsavedChanges(hasUnsavedChanges);
    }
    else {
      const hasUnsavedChanges =
        patientListName !== initialPatientListName.current ||
        checkedList.length !== initialCheckedList.current.length ||
        !checkedList.every((id, index) => id === initialCheckedList.current[index]);
      setUnsavedChanges(hasUnsavedChanges);
    }
  }, [patientListName, checkedList]);

  React.useEffect(() => {
    if (patientListId) {
      getPatientList();
    }
  }, [patientListId]);

  return (
    <div className="patient-list-create-container">
      {unsavedChanges && (
        <UnsavedChangesModal unsavedChanges={unsavedChanges} />
      )}
      <div className="container2">
        <Grid item xs={12}>
          <Grid container>
            <Grid
              container
              justifyContent="space-between"
              className="floating-header"
            >
              <Grid item xs={2} className="list-create-header">
                {patientListName ? (
                  <span
                    style={{
                      fontSize: "24px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "normal",
                      color: "black",
                      whiteSpace: 'nowrap'
                    }}
                    title={patientListName}
                  >
                    {patientListName.length > 26 ? `${patientListName.substring(0, 23)}...` : patientListName}
                  </span>
                ) : (
                  <span
                    style={{
                      fontSize: "24px",
                      fontStyle: "normal",
                      fontWeight: 700,
                      lineHeight: "normal",
                      color: "black",
                    }}
                  >
                    Unsaved List
                  </span>
                )}
                <CreateIcon
                  className="cursor-pointer"
                  onClick={() => {
                    setEditTitle(true);
                  }}
                />
              </Grid>
              <PendingActionWidget
                checkedList={checkedList}
                pendingAdd={pendingAdd}
                pendingRemoval={pendingRemoval}
                onList={onList}
                handleCreate={handleSave}
                handleDiscard={handleDiscard}
                handleSave={handleSave}
                patientListId={patientListId}
              />
            </Grid>
            <div className="divider"></div>
            <Grid item xs={3}>
              <SearchToolsWidget
                user_id={props.user_id}
                patientListId={patientListId}
                csrfToken={props.csrfToken}
                setSearchPatients={setSearchPatients}
                setCheckedList={setInitialCheckedList}
                setOnList={setOnList}
                pendingAdd={pendingAdd}
                setPendingAdd={setPendingAdd}
                setPendingRemoval={setPendingRemoval}
                checkedList={checkedList}
                setParamsPresent={setParamsPresent}
                setLoading={setLoading}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                setTotalPages={setTotalPages}
                sortObject={sortObject}
                setSortObject={setSortObject}
                allMatchingPatientIds={allMatchingPatientIds}
                setAllMatchingPatientIds={setAllMatchingPatientIds}
                isSelectAllActive={isSelectAllActive}
                setIsSelectAllActive={setIsSelectAllActive}
                getAllMatchingPatients={() => allMatchingPatientsRef.current}
                allMatchingPatientsRef={allMatchingPatientsRef}
              />
            </Grid>
            <Grid item xs={9}>
              <SearchResultsWidget
                patientListId={patientListId}
                csrfToken={props.csrfToken}
                searchPatients={searchPatients}
                setSearchPatients={setSearchPatients}
                checkedList={checkedList}
                setCheckedList={setCheckedList}
                setOnList={setOnList}
                setPendingAdd={setPendingAdd}
                setPendingRemoval={setPendingRemoval}
                onList={onList}
                pendingAdd={pendingAdd}
                pendingRemoval={pendingRemoval}
                paramsPresent={paramsPresent}
                loading={loading}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalPages={totalPages}
                sortObject={sortObject}
                setSortObject={setSortObject}
                allMatchingPatientIds={allMatchingPatientIds}
                isSelectAllActive={isSelectAllActive}
                setIsSelectAllActive={setIsSelectAllActive}
                getAllMatchingPatients={() => allMatchingPatientsRef.current}
              />
            </Grid>
          </Grid>
        </Grid>
      </div>

      <EditTitleModal
        open={editTitle}
        setOpen={setEditTitle}
        listName={patientListName}
        setListName={setPatientListName}
        initialPatientListName={initialPatientListName}        
        title={patientListId ? "Edit Patient List Name" : "Name Patient List"}
        successCallback={updateName}
      />

      <EditTitleModal
        open={editMissingTitle}
        setOpen={setEditMissingTitle}
        listName={patientListName}
        setListName={setPatientListName}
        initialPatientListName={initialPatientListName}        
        title={patientListId ? "Edit Patient List Name" : "Name Patient List"}
        successCallback={handleSave}
      />
    </div>
  );
};

export default PatientListCreate;

